"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Model = exports.Model = function () {
  function Model(Thor, operator, endpoint) {
    var Custom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Model);

    this.Thor = Thor;
    this.operator = operator;
    this.namespace = endpoint.namespace;
    this.prefixKey = endpoint.prefixKey;
    this.total_pages = null;
    this.total_count = null;
    this.current_page = null;
    this.collection = [];

    for (var method in Custom) {
      this[method] = Custom[method];
    }
  }

  _createClass(Model, [{
    key: "action",
    value: function action() {
      return this.Thor._routes[this.operator];
    }
  }, {
    key: "get",
    value: function get() {
      var _this = this;

      var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.action().list(conditions, options, function (xhr, response) {
        _this.collection = response[_this.operator];
        _this.total_pages = response.meta.total_pages;
        _this.current_page = response.meta.current_page;
        _this.total_count = response.meta.total_count;
        return _this.collection;
      });
    }
  }, {
    key: "create",
    value: function create() {
      var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.action().create(conditions, options);
    }
  }, {
    key: "show",
    value: function show() {
      var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.action().show(conditions, options);
    }
  }, {
    key: "update",
    value: function update() {
      var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.action().update(conditions, options);
    }
  }, {
    key: "delete",
    value: function _delete() {
      var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.action()["delete"](conditions, options);
    }
  }, {
    key: "list",
    value: function list() {
      return this.collection;
    }
  }]);

  return Model;
}();